<template>
  <div class="home-page-group-content">
    <div class="header-group-content-top">
      <span><img :src="icon" alt=""></span>
      <span class="message">{{title}}</span>
    </div>
    <div class="header-group-content-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "",
      required: true
    },
    title: {
      type: String,
      default: "这是一个标题",
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.home-page-group-content {
  width: 100%;
  .header-group-content-top {
    margin-bottom: 30px;
    .message{
      margin-left: 15px;
    }
  }
}
</style>